export const DEFAULT = Symbol('Default') as symbol

export function match<
  K extends string | number | symbol | typeof match.DEFAULT,
  R,
>(matchOn: K, cases: Record<K, () => R>): R {
  const val =
    matchOn in cases
      ? cases[matchOn]
      : DEFAULT in cases
        ? cases[DEFAULT as K]
        : noMatch(matchOn as string)

  return val()
}

function noMatch(matchOn: string) {
  return () => {
    throw new Error('No match for ' + matchOn)
  }
}

match.DEFAULT = DEFAULT
